import React, { useEffect, useState } from 'react'
import './Blogs.css';
import axios from 'axios'
import { Link } from 'react-router-dom';


const Blogs = () => {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)

        const getBlogs = async () => {
            try {
                const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getblogs`);
                const array = data.data;
                setBlogs(array);
                console.log(array);

            } catch (err) {
                console.log(err);
            }
        }

        getBlogs();
    }, [])



    return (
        <div className='Blogs'>

            <div className='flex flex-col text-center gap-2 mt-10'>
                <div className='text-black font-bold'>Resources</div>
                <div className='text-4xl font-black text-[var(--primary)]'>Blogs</div>

            </div>

            <div className='blogsContainer'>

                {blogs?.length > 0 ?
                    blogs?.map(blog => (
                        <Link to={`/blogs/${blog?._id}`} key={blog?._id}>
                            <div className='blogBox'>
                                <div className='blogImg'>
                                    <img src={blog?.image} />
                                </div>
                                <div className='blogContent'>
                                    <div className='blogTime'>
                                        Posted {blog?.createdAt && new Date(blog.createdAt).toLocaleDateString()}
                                    </div>
                                    <div className='blogHead'>
                                        {blog?.title}
                                    </div>
                                    <div className='blogText'>
                                        {blog?.paragraphs &&
                                            blog?.paragraphs[0]}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))

                    :
                    <div>no blogs to show</div>
                }


            </div>

        </div>
    )
}

export default Blogs

const blogs1 = [
    {
        _id: "1",
        imageURL: "https://images.unsplash.com/photo-1456324504439-367cee3b3c32?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        blogTime: "5 min",
        blogTitle: "How to Ace Your Next Job Interview",
        blogText: "Learn the best strategies to prepare for interviews, from researching companies to answering tricky questions."
    },
    {
        _id: "2",
        imageURL: "https://plus.unsplash.com/premium_photo-1661288470388-c5006797bdff?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        blogTime: "7 min",
        blogTitle: "Crafting a Resume That Gets You Hired",
        blogText: "Discover tips on creating a compelling resume that stands out to recruiters and hiring managers."
    },
    {
        _id: "3",
        imageURL: "https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        blogTime: "6 min",
        blogTitle: "Top 5 In-Demand Remote Jobs in 2025",
        blogText: "Explore the growing trend of remote work and the best job roles offering flexibility and high pay."
    },
    {
        _id: "4",
        imageURL: "https://plus.unsplash.com/premium_photo-1661906789703-a25a1e53180e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        blogTime: "4 min",
        blogTitle: "Why Networking is the Key to Career Growth",
        blogText: "Learn how building connections can open doors to new job opportunities and career advancements."
    }
]